import { NivelI } from "interfaces/Nivel";
import { TituloI } from "../interfaces/Titulo";

export interface infoFetchGetTituloI {
  id: number | string;
  nombre: string;
  descripcion: string;
  nivel: NivelI;
}

class Titulo implements TituloI {
  id: number | string;
  nombre: string;
  descripcion: string;
  nivel: NivelI;

  constructor(dto: infoFetchGetTituloI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
    this.descripcion = dto.descripcion;
    this.nivel = dto.nivel;
  }
}

export const makeTitulo = (infoFetch: infoFetchGetTituloI) => {
  return new Titulo(infoFetch);
};
